"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativePresetTitleTranslated = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var intlIdDict = {
    "GDC.time.date": "filters.day.title",
    "GDC.time.week_us": "filters.week.title",
    "GDC.time.month": "filters.month.title",
    "GDC.time.quarter": "filters.quarter.title",
    "GDC.time.year": "filters.year.title",
};
exports.RelativePresetTitleTranslated = function (_a) {
    var granularity = _a.granularity;
    var intlId = intlIdDict[granularity] || null;
    if (!intlId) {
        return null;
    }
    return react_1.default.createElement(react_intl_1.FormattedMessage, { id: intlId });
};
//# sourceMappingURL=RelativePresetTitleTranslated.js.map